import axios from "axios"
import { Dispatch, SetStateAction } from "react"
import constants from "../../../constants"
import GroupDialog from "./GroupDialog"
import { Groups, OpenGroupModal } from '../../../types'
import { addError, addSuccess } from "../../../redux/alerts"
import { useAppDispatch } from "../../../redux/store"

type GroupEditDialogProps = {
  open: boolean,
  customerNumber: string,
  setOpenModal: Dispatch<SetStateAction<OpenGroupModal>>,
  selectedGroup: Groups | null,
}

const getEditCustomerGroup = (selectedGroup: Groups | null ) => {
  const editCustomerGroup = async (groupName: string, customerNumber: string) => {
    const groupId = selectedGroup?.group_id
 
    const response = await axios.put(`${constants.ONTRAQ_API_URL}/api2/${customerNumber}/groups/${groupId}`, {
      name: groupName.trim(),
    })

    return response.data
  }

  return editCustomerGroup
}

const GroupEditDialog = (props: GroupEditDialogProps) => {
  const { open, setOpenModal, customerNumber, selectedGroup } = props
  const dispatch = useAppDispatch()
  const handleSuccess = (group: Groups) => {
    const groupName = group?.name
    dispatch(addSuccess(`Group name updated to ${groupName}`))
  }

  const handleError = () => {
    dispatch(addError('There was a problem updating the group'))
  }

  const handleClose = () => {
    setOpenModal({ open: false, type: 'edit' })
  }

  const service = getEditCustomerGroup(selectedGroup)
  const groupName = selectedGroup?.name ?? ''

  return selectedGroup ? (
    <GroupDialog
      open={open}
      customerNumber={customerNumber}
      title="Edit Group"
      saveText="Save"
      defaultGroupName={groupName}
      icon="trash-can"
      handleClose={handleClose}
      handleSuccess={handleSuccess}
      handleError={handleError}
      service={service}
    />
  ) : null
}

export default GroupEditDialog
